import { render, staticRenderFns } from "./PeopleNameCell.vue?vue&type=template&id=564d8b18&scoped=true&"
import script from "./PeopleNameCell.vue?vue&type=script&lang=js&"
export * from "./PeopleNameCell.vue?vue&type=script&lang=js&"
import style0 from "./PeopleNameCell.vue?vue&type=style&index=0&id=564d8b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d8b18",
  null
  
)

export default component.exports